import widgetConfigurations from '../configurations/widgetConfigurations.json';
import { filterInWidgets, WIDGET_TYPES, WIDGETS } from 'slykit';
import { config } from '../widgets/innovation/config';

/**
 * Loads the application configuration information from files.
 *
 * @returns {object}
 */
export function useLoadApplicationSpecificStateLocal() {
	// inject local vis
	WIDGET_TYPES['INNOVATION'] = 'INNOVATION';
	WIDGETS[WIDGET_TYPES.INNOVATION] = config;

	const wantedWidgets = [
		WIDGET_TYPES.TYPOGRAPH,
		WIDGET_TYPES.CUSTOM_CIRCLE_PACK,
		WIDGET_TYPES.BIPARTITE_GRAPH,
		WIDGET_TYPES.DONUT_GRAPH,
		WIDGET_TYPES.TABLE,
		WIDGET_TYPES.STACKED_BAR_GRAPH,
		WIDGET_TYPES.PARACORD,
		WIDGET_TYPES.NETWORK_GRAPH,	
		WIDGET_TYPES.POLAR_AREA,
		WIDGET_TYPES.TREE_MAP,
		WIDGET_TYPES.NODE_GRAPH,
	];

	// widget order is a new default for all docs projects
	const widgetOrder = [
		// WIDGET_TYPES.TREE_MAP,
		WIDGET_TYPES.TYPOGRAPH,
		WIDGET_TYPES.CUSTOM_CIRCLE_PACK,
	];

	// currently using all of the widgets
	let widgets = filterInWidgets(
		wantedWidgets,
		widgetConfigurations,
		widgetOrder
	);

	return {
		savedStates: {
			widgets: widgets.reduce(
				(map, obj) => ({
					...map,
					[obj.key]: obj,
				}),
				{}
			),
		},
	};
}
